/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientInstructionsModel } from '../../models/patient-instructions-model';

export interface SavePatientInstructions$Params {
  patientID?: number;
      body?: PatientInstructionsModel
}

export function SavePatientInstructions(http: HttpClient, rootUrl: string, params?: SavePatientInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, SavePatientInstructions.PATH, 'post');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

SavePatientInstructions.PATH = '/api/Supervisor/SavePatientInstructions';
